import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import AdminOverview from './AdminOverview';
import ClientsManagement from './ClientsManagement';
import EventsManagement from './EventsManagement';
import BettingManagement from './BettingManagement';
import AdminSettings from './AdminSettings';
import TeamsManagement from './TeamsManagement';
import TransactionsManagement from './TransactionsManagement';
import PoolsManagement from './PoolsManagement';

const AdminDashboard = () => {
  return (
    <AdminLayout>
      <Routes>
        <Route index element={<AdminOverview />} />
        <Route path="clients/*" element={<ClientsManagement />} />
        <Route path="events/*" element={<EventsManagement />} />
        <Route path="betting/*" element={<BettingManagement />} />
        <Route path="teams" element={<TeamsManagement />} />
        <Route path="pots" element={<PoolsManagement />} />
        <Route path="transactions" element={<TransactionsManagement />} />
        <Route path="settings" element={<AdminSettings />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminDashboard;